import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { iCourtFormValues } from '@services/CourtService';
import { tile } from '@interfaces/interfaces';
import { CheckboxInput, TileRadio } from '@components';

function CourtStep11(): ReactElement {
  const { values }: { values: iCourtFormValues } = useFormikContext();
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'I do',
    },
    {
      body: <NoValue />,
      value: 'I do not',
    },
  ];
  const SOIntend = {
    formikName: 'intend',
    title: 'Are you intending to defend the charge outlined in your Infringement Notice?',
  };
  return (
    <>
      <div className="vfH2">Declaration</div>
      {values.SeriousObligation && <Field name={SOIntend.formikName} component={TileRadio} tileData={TILE_DATA} title={SOIntend.title} isMandatory orientationRow />}
      {values.SeriousObligation ? (
        <div>
          <p>I object to this Infringement Notice.</p>
          <p>I refuse to pay the penalty and request that the matter be dealt with by a court.</p>
          <p>I understand that I may receive a summons that requires me to attend court.</p>
        </div>
      ) : (
        <div>
          <p>
            I elect to have the matter heard and determined by a court.
          </p>
          <p>I understand that I may receive a summons that requires me to attend court.</p>
        </div>
      )}
      <p>I declare that the information that I have supplied in this form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
      <Field component={CheckboxInput} name="declaration" title="I agree to the statements above" />
    </>
  );
}

export default CourtStep11;
